"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormView = void 0;
const views_1 = require("./views");
const i18n_1 = require("../../exports/i18n");
const config_1 = require("../../config");
const utils_1 = require("../../utils");
class FormView extends views_1.View {
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.form_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.form_view_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_form_guide_video.value),
        };
    }
    static generateDefaultProperty() {
        return null;
    }
}
exports.FormView = FormView;
//# sourceMappingURL=form_view.js.map